export default __webpack_public_path__ + "static/media/bananaAndStrawberries.27d1fe33.jpg";